import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./ModalActions.module.scss";

const ModalActions = ({ children, isCardAction, className }) => {
  return <div className={cx(styles.actions, { [styles.cardActions]: isCardAction }, className)}>{children}</div>;
};

ModalActions.defaultProps = {
  className: undefined,
  isCardAction: false
};

ModalActions.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** to style actions section for card component */
  isCardAction: PropTypes.bool
};

export default ModalActions;
